<template>
  <dl
    :class="getItemClasses(item.Type, hasSubitems)"
   
    @click="toggleSubitems"
  >
    <dt class="flex items-center gap-2 min-w-0">
      <template v-if="item.Type === 'SecurityDeposit' && item.Details">
        <button
          class="wrap-anywhere min-w-0 link-muted cursor-pointer"
         
          @click.stop="openDetailsModal"
        >
          {{ item.Label?.[localeKey] }}
        </button>

        <TModalCritical
          v-model:visible="isDetailsModalOpen"
          :title="item.Details.Title?.[localeKey] ?? ''"
          :label-primary="t('actions.gotIt')"
          size="lg"
          @action:primary="(dismiss) => dismiss()"
        >
          <p
            v-if="item.Details.Description"
           
            class="mb-6"
          >
            {{ item.Details.Description[localeKey] }}
          </p>

          <dl
            v-if="item.Details.Rows?.length"
            class="space-y-3"
          >
            <div
              v-for="row in item.Details.Rows"
              :key="row.Label?.[localeKey]"
              class="flex justify-between gap-4 lg:gap-8"
            >
              <dt class="shrink-0">
                {{ row.Label?.[localeKey] }}
              </dt>
              <dd :class="['text-right', { 'font-semibold': row.Style === 'Bold' }]">
                {{ row.Value?.[localeKey] }}
              </dd>
            </div>
          </dl>
        </TModalCritical>
      </template>

      <template v-else>
        <span
          class="wrap-anywhere min-w-0"
         
        >
          {{ item.Label?.[localeKey] }}
        </span>

        <TTooltipIcon
          v-if="item.Description"
          :title="item.Label?.[localeKey] ?? ''"
          :content="item.Description?.[localeKey]"
          icon-variant="muted"
          modal-type="critical"
          class="ml-1 align-text-top"
        />
      </template>

      <TIcon
        v-if="item.Items && item.Items.length > 0"
        :icon="['fas', 'chevron-down']"
        size="sm"
        :class="isOpen ? 'rotate-180' : ''"
      />
    </dt>
    <dd
      :class="getItemValueClasses(item.Type)"
     
    >
      {{ item.Value?.[localeKey] }}
    </dd>
  </dl>

  <div
    v-if="item.Items && item.Items.length > 0"
    v-show="isOpen"
    class="space-y-1"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { BookingPriceBreakdownItem } from '~/types'

const props = defineProps<{
  item: BookingPriceBreakdownItem
}>()

const { localeKey } = useLocaleKey()
const { t } = useI18n()

const isOpen = ref(false)
const hasSubitems = computed(() => Boolean(props.item.Items))

function toggleSubitems() {
  if (!props.item.Items) {
    return
  }

  isOpen.value = !isOpen.value
}

function getItemClasses(type: BookingPriceBreakdownItem['Type'], hasSubitems: boolean) {
  return [
    'flex justify-between gap-2 align-top',
    { 'cursor-pointer': hasSubitems },
    { 'text-secondary font-semibold': type === 'Discount' || type === 'PromoCode' },
    { 'font-semibold border-y border-gray-200 py-2': type === 'SubTotal' },
    { 'font-semibold text-lg border-t border-gray-200 py-3 mb-0 mt-3': type === 'Total' },
  ]
}

function getItemValueClasses(type: BookingPriceBreakdownItem['Type']) {
  return [
    'text-right',
    { 'text-secondary': type === 'Free' },
  ]
}

const isDetailsModalOpen = ref(false)

function openDetailsModal() {
  isDetailsModalOpen.value = true
}
</script>
